import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createPost } from '../services/postService';
import { logger } from '../utils/logger';

interface CreatePostResponse {
  success: boolean;
  data?: any;
  message?: string;
}

export const useCreatePost = () => {
  const queryClient = useQueryClient();
  
  return useMutation<CreatePostResponse, Error, { postData: any; isFormData?: boolean }>({
    mutationFn: async ({ postData, isFormData = false }): Promise<CreatePostResponse> => {
      try {
        logger.info('useCreatePost', 'Creating new post');
        const result = await createPost(postData, isFormData);
        
        logger.info('useCreatePost', 'Post created successfully');
        return {
          success: true,
          data: result
        };
      } catch (error) {
        logger.error('useCreatePost', 'Error creating post:', error);
        throw error;
      }
    },
    onSuccess: () => {
      // Invalidate the posts query to refetch the list
      queryClient.invalidateQueries({ queryKey: ['posts'] });
      logger.info('useCreatePost', 'Posts queries invalidated');
    }
  });
}; 